// Cross-site link configuration for EvidentTrail
// Marketing site links to app subdomain for authenticated routes

// App URL is configurable via env var, with smart defaults
const getAppUrl = (): string => {
  // In production, use the configured URL or default to app subdomain
  if (import.meta.env.VITE_APP_URL) {
    return import.meta.env.VITE_APP_URL;
  }
  
  // In development, use localhost
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5174';
    }
  }
  
  // Default to production app subdomain
  return 'https://app.evidenttrail.com';
};

export const APP_URL = getAppUrl();

// Helper to create app links
export const appLinks = {
  login: `${APP_URL}/login`,
  register: `${APP_URL}/register`,
  dashboard: `${APP_URL}/dashboard`,
  settings: `${APP_URL}/settings`,
};

// Marketing URL for app-to-marketing links
const getMarketingUrl = (): string => {
  if (import.meta.env.VITE_MARKETING_URL) {
    return import.meta.env.VITE_MARKETING_URL;
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5173';
    }
  }
  
  return 'https://evidenttrail.com';
};

export const MARKETING_URL = getMarketingUrl();
